import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Unpaid from './Unpaid';
import ShowUnpaid from './ShowUnpaid';

const UnpaidRouter = () => {
  return (
    <Routes>
      <Route path="show/:id" element={<ShowUnpaid />} />
      <Route index element={<Unpaid />} />
    </Routes>
  );
};

export default UnpaidRouter;
